import MessengerHub from "./MessengerHub";


export class CurrierBase {

    protected messengerHub:MessengerHub
    protected mailboxes = [];

    constructor(){
        this.mailboxes = [];
    }

    onRegister(messengerHub){
        this.messengerHub = messengerHub;
    }

    receiveMessage(packagedMessage){
        this.onMessageReceived(this.unpackMessage(packagedMessage));
    }

    onMessageReceived(message){
        if(!message) return;
        this.messengerHub.onMessageReceived(message, this);
    }

    // ==============================
    //      GET NAME
    //  getName is used to register the currier.  It's a function so
    //  that multiple instanitations of the same class could be used in the same
    //  message hub
    // ==============================
    getName(){
        return  this.constructor.name;
    }

    sendMessage(message) {
        this.onSendMessage(this.packMessage(message))
    }

    onSendMessage(packagedMessage){

    }

    // ================================================
    //          MESSAGE PACKAGING FOR EASY HOOKS
    // ================================================
    packMessage(message, responseKey=null) {
        return message;
    }

    unpackMessage(message) {
        return message;
    }


}

export default CurrierBase;

